import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=fe4cdc88"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=fe4cdc88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports